import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import GoodsTransfersOrdersDetailSkeleton from "./GoodsTransfersOrdersDetailSkeleton";
import { GoodsTransfersOrdersDto } from "../../../../../dtos/documents/GoodsTransfersOrders/GoodsTransfersOrdersDto";
import { GoodsTransfersOrdersModel } from "../../../../../models/Documents/GoodsTransfersOrders/GoodsTransfersOrdersModel";
import { NewDocumentModalViewContext } from "../../../../Shared/NewDocumentModalView";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../../Shared/NewForms/NFTab";
import { DocumentModalViewHeader } from "../../../../Shared/DocumentModalViewHeader";
import { NFTabContainer } from "../../../../Shared/NewForms/NFTabContainer";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../../Shared/NewForms/NFLookupWarehouse";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFormTable } from "../../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../../Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "../../../../Shared/NewForms/NFLookupUnit";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFTextAreaInput } from "../../../../Shared/NewForms/NFTextAreaInput";
import { GoodsTransfersOrdersDetailFooter } from "./GoodsTransfersOrdersDetailFooter";
import { AppEntities } from "../../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../../helpers/SaveObjectToExcel";
interface IProps {
  model: GoodsTransfersOrdersDto | null;
  modelUpdatedEvent: (newModel: GoodsTransfersOrdersDto) => void;
}

export const GoodsTransfersOrdersDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<GoodsTransfersOrdersModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("goodsTransferOrderGoods");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Goods Transfer Orders");

  useEffect(() => {
    console.log(model);
    register("goodsTransferOrderGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("companyId", model.companyId);
      setValue("warehouseId", model.warehouseId);
      setValue("divisionId", model.divisionId);
      setValue("comment", model.comment);
      setValue("desiredShippingDate", model.desiredShippingDate);
      setValue("createdDate", model.createdDate);
      setValue("goodsTransferOrderGoods", model.goodsTransferOrderGoods);
      // setValue("postingOfGoodGoods", model.postingOfGoodGoods);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: GoodsTransfersOrdersModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: GoodsTransfersOrdersDto = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: GoodsTransfersOrdersModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <GoodsTransfersOrdersDetailSkeleton />
      </>
    );
  }
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.GoodsTransfersOrders.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`goodsTransferOrderGoods.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`goodsTransferOrderGoods.${index}.amount`, newAmount);
    console.log(newAmount);
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput fieldName={"desiredShippingDate"} title={"Desired Shipping Date"} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision fieldName={"divisionId"} title={"Division"} companyId={watch("companyId")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupWarehouse fieldName={"warehouseId"} title={"Warehouse"} companyId={watch("companyId")} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company "} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"goodsTransferOrderGoods"}>
            <NFTextInput title="vendorCode" fieldName="vendorCode" />
            <NFLookupProduct fieldName={"productId"} title={"Product"} required={true} width={200} />
            <NFTextInput title="productCode" fieldName="productCode" />
            <NFLookupUnit title="unitId" fieldName="Unit" width={200} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} onValueChanged={handleQuantityChanged} />
            <NFIntInput fieldName={"price"} title={"Price"} onValueChanged={handlePriceChanged} />
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <GoodsTransfersOrdersDetailFooter />
    </FormProvider>
  );
};
